import imgNamee81 from "./img-namee8 (1).webp";
import imgNamee82 from "./img-namee8 (2).webp";

const imgNamee8 = [imgNamee81, imgNamee82];

export default imgNamee8;
